import { render } from "./RecreationDetailsWrapper.vue?vue&type=template&id=e2640380"
import script from "./RecreationDetailsWrapper.vue?vue&type=script&lang=js"
export * from "./RecreationDetailsWrapper.vue?vue&type=script&lang=js"

import "./RecreationDetailsWrapper.vue?vue&type=style&index=0&id=e2640380&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "e2640380"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e2640380', script)) {
    api.reload('e2640380', script)
  }
  
  module.hot.accept("./RecreationDetailsWrapper.vue?vue&type=template&id=e2640380", () => {
    api.rerender('e2640380', render)
  })

}

script.__file = "src/components/recreation/RecreationDetailsWrapper.vue"

export default script